var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shows ? _c('v-layout', {
    staticStyle: {
      "gap": "8px"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "outlined": "",
      "rounded": "xl"
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "white",
    attrs: {
      "small": "",
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.increaseZoom
    }
  }, 'v-btn', {
    disabled: _vm.disabled_increase
  }, false), [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1), _c('v-card', {
    attrs: {
      "flat": "",
      "outlined": "",
      "rounded": "xl"
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "white",
    attrs: {
      "small": "",
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.decreaseZoom
    }
  }, 'v-btn', {
    disabled: _vm.disabled_decrease
  }, false), [_c('v-icon', [_vm._v("mdi-minus")])], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }